var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#555C5D",
    d: "M48 26c5.52 0 10 4.48 10 10 0 2.96-1.32 5.56-3.32 7.4L69.2 57.92C73.12 50.48 76 42.72 76 36 76 20.52 63.48 8 48 8c-7.92 0-15.04 3.32-20.16 8.6L40.6 29.36C42.44 27.28 45.04 26 48 26m17.48 38.4L46.96 45.88l-.44-.44L13.08 12 8 17.08 20.72 29.8c-.44 2-.72 4.08-.72 6.2 0 21 28 52 28 52s6.68-7.4 13.52-17.4L74.92 84 80 78.92z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v96H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOff);
export default __webpack_public_path__ + "static/media/marker-off.a46cf85b21b1e3e1964be90baf3404b4.svg";
export { ForwardRef as ReactComponent };